import { ReactNode } from "react";

const ProtectAdminRouter = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};

export default ProtectAdminRouter;
